import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/downlineProfile";
import { useAppSelector } from "../../../../store";
import { getSopStatusForAbo, SOP_STATUS_KPI_ORDER } from "./sopStatusData";
import { SopLegendIcon } from "./Shared/LegendIcon";
import { SopCard } from "./SopCard/SopCard";
import "./SopStatus.scss";

const KpiTile = ({ title, value }: { title: string; value: string }) => {
  return (
    <div className="SopStatus__KpiTile">
      <span className="SopStatus__KpiTileTitle">{title}</span>
      <span className="SopStatus__KpiTileValue">{value}</span>
    </div>
  );
};

export const SopStatus = () => {
  const { t } = useTranslation("downlineProfile");
  const affAbo = useAppSelector((state) => state.downlineProfile.affAbo);
  const { kpis, subscriptions } = getSopStatusForAbo(affAbo);
  return (
    <div className="SopStatus">
      <section className="SopStatus__kpiTiles">
        {SOP_STATUS_KPI_ORDER.map((key) => (
          <KpiTile
            key={key}
            title={t(`sopStatus.tiles.${key}`, defaultContent.sopStatus.tiles[key])}
            value={String(kpis[key])}
          />
        ))}
      </section>

      <section className="SopStatus__ProductInfoHeader">
        <h3>{t("sopStatus.sopProductInfo", defaultContent.sopStatus.sopProductInfo)}</h3>

        <div className="SopStatus__ProductInfoLegend">
          <div>
            <SopLegendIcon type="promo" />
            {t("sopStatus.promoMonth", defaultContent.sopStatus.promoMonth)}
          </div>
          <div>
            <SopLegendIcon type="expiry" />
            {t("sopStatus.expiryMonth", defaultContent.sopStatus.expiryMonth)}
          </div>
        </div>
      </section>

      <section className="SopStatus__SopCards">
        {subscriptions.map((subscription) => (
          <SopCard key={`${subscription.productName}-${subscription.startDate}`} subscription={subscription} />
        ))}
      </section>
    </div>
  );
};
